export { default as Graphic, graphicVariants, graphicFillVariants } from './Graphic.component'
